import React from 'react';

import '../App.css';

function Howitworks() {
  const steps = [
    {
      id: "01",
      title: "Download the App",
      desc: "Get started by downloading our user-friendly app from Play Store or App Store. Managing your laundry is now just a tap away.",
      img: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?q=80&w=500",
      icon: "fas fa-mobile-alt",
      align: "left"
    },
    {
      id: "02",
      title: "Schedule Pickup",
      desc: "Choose a time and location that fits your busy schedule. Our flexible slots ensure we are there when you need us.",
      img: "https://images.unsplash.com/photo-1592890288564-76628a30a657?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      icon: "fas fa-calendar-check",
      align: "right"
    },
    {
      id: "03",
      title: "We Collect",
      desc: "Our professional delivery partner arrives at your doorstep to collect your garments safely. No more carrying heavy bags!",
      img: "https://images.unsplash.com/photo-1582735689369-4fe89db7114c?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      icon: "fas fa-truck-loading",
      align: "left"
    },
    {
      id: "04",
      title: "Cleaning Process",
      desc: "Your clothes undergo expert treatment, from stain removal to premium washing and steam pressing by our certified professionals.",
      img: "https://images.unsplash.com/photo-1545173168-9f1947eebb7f?q=80&w=500",
      icon: "fas fa-soap",
      align: "right"
    },
    {
      id: "05",
      title: "Fast Delivery",
      desc: "Within 24 hours, your fresh, clean, and crisp clothes are delivered back to your doorstep. Ready to wear and impress!",
      img: "https://plus.unsplash.com/premium_photo-1661326268221-bf262de801b8?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      icon: "fas fa-shipping-fast",
      align: "left"
    }
  ];

  return (
    <div className="how-it-works-page">
      {/* Hero Section */}
      <section className="how-hero">
        <div className="container">
          <span>Our Process</span>
          <h1>Simplicity In Every <span>Step</span></h1>
          <p>We've made laundry as easy as ordering a pizza. See how we transform your wardrobe in 5 simple steps.</p>
        </div>
      </section>

      {/* Steps Timeline Section */}
      <section className="timeline-section">
        <div className="timeline-container">
          <div className="center-line"></div>
          
          {steps.map((step, index) => (
            <div className={`timeline-item ${step.align}`} key={index}>
              <div className="timeline-dot">
                <i className={step.icon}></i>
              </div>
              
              <div className="timeline-content">
                <div className="step-tag">{step.id}</div>
                <div className="timeline-image">
                  <img src={step.img} alt={step.title} />
                </div>
                <div className="timeline-text">
                  <h3>{step.title}</h3>
                  <p>{step.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="quality-checklist-section">
  <div className="quality-container">
    <div className="quality-text-side">
      <span className="subtitle">Our Promise</span>
      <h2>Quality Check</h2>
      <p>Before any garment leaves our facility, it must pass our rigorous quality standards. We care for your clothes as much as you do.</p>
      
      <div className="checklist-wrapper">
        <div className="check-item">
          <div className="check-icon"><i className="fas fa-search"></i></div>
          <div className="check-info">
            <h4>Stain Check</h4>
            <p>Every inch is inspected to ensure even the toughest stains are completely removed.</p>
          </div>
        </div>

        <div className="check-item">
          <div className="check-icon"><i className="fas fa-cut"></i></div>
          <div className="check-info">
            <h4>Button & Zip Check</h4>
            <p>We ensure all buttons are intact and zippers are functioning smoothly before packing.</p>
          </div>
        </div>

        <div className="check-item">
          <div className="check-icon"><i className="fas fa-wind"></i></div>
          <div className="check-info">
            <h4>Fragrance Check</h4>
            <p>A final touch of premium, mild fragrance to keep your clothes smelling fresh for days.</p>
          </div>
        </div>

        <div className="check-item">
          <div className="check-icon"><i className="fas fa-check-double"></i></div>
          <div className="check-info">
            <h4>Fabric Integrity</h4>
            <p>Ensuring the texture and color of the fabric remain as vibrant as new.</p>
          </div>
        </div>
      </div>
    </div>

    <div className="quality-image-side">
      <div className="quality-badge-circle">
        <div className="inner-circle">
          <i className="fas fa-shield-alt"></i>
          <span>Guaranteed<br/>Quality</span>
        </div>
      </div>
      <img src="https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=600" alt="Quality Control" />
    </div>
  </div>
</section>

      {/* Final Call to Action */}
      <section className="how-cta">
        <div className="cta-box-gradient">
          <h2>Ready to experience the magic?</h2>
          <p>Join thousands of happy customers in the UAE today.</p>
          <div className="app-buttons">
            <button className="btn-app"><i className="fab fa-apple"></i> App Store</button>
            <button className="btn-app"><i className="fab fa-google-play"></i> Play Store</button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Howitworks;